import type { DetailedWorkspace, NavItemType } from "common/types";

import Banners from "../Banners";
import SubscriptionActivation from "../SubscriptionActivation";
import MobileHeader from "./MobileHeader";

import type { ReactNode } from "react";

interface MobileLayoutProps {
  navItems: NavItemType[];
  children: ReactNode;
  workspace: DetailedWorkspace;
  isLocked: boolean;
}
export default function MobileLayout({
  navItems,
  children,
  workspace,
  isLocked,
}: MobileLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <MobileHeader navItems={navItems} />

      <div className="flex grow flex-col">
        {isLocked ? (
          <SubscriptionActivation />
        ) : (
          <>
            <section aria-label="Banners" className="empty:hidden px-4 pt-6">
              {workspace && <Banners />}
            </section>

            {children}
          </>
        )}
      </div>
    </div>
  );
}
